// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scope.row .right.floated.right.aligned.two.wide.column[data-v-c7eff456]{padding:0 .5rem}.ui.grid.scopes[data-v-c7eff456]{margin:0 0 20px -14px}.ui.grid>.scope.row .column[data-v-c7eff456]{margin-top:5px}.scope .ui.toggle.checkbox[data-v-c7eff456]{margin:5px 0 0}.scope .ui.toggle.checkbox label[data-v-c7eff456]{font-family:DaimlerCS-Regular,sans-serif;font-weight:700;font-size:20px}@media only screen and (max-width:600px){.scope-name[data-v-c7eff456]{width:220px}}", ""]);
// Exports
module.exports = exports;
